import { render, staticRenderFns } from "./MetricItem.vue?vue&type=template&id=87feedb8&"
import script from "./MetricItem.vue?vue&type=script&lang=js&"
export * from "./MetricItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports